export const FLOATING_POSITION_DATA = [
  { label: 'top', value: 'top' },
  { label: 'top-start', value: 'top-start' },
  { label: 'top-end', value: 'top-end' },
  { label: 'left', value: 'left' },
  { label: 'left-start', value: 'left-start' },
  { label: 'left-end', value: 'left-end' },
  { label: 'right', value: 'right' },
  { label: 'right-start', value: 'right-start' },
  { label: 'right-end', value: 'right-end' },
  { label: 'bottom', value: 'bottom' },
  { label: 'bottom-start', value: 'bottom-start' },
  { label: 'bottom-end', value: 'bottom-end' },
];

export const FLOATING_ARROW_POSITION_DATA = [
  { label: 'side', value: 'side' },
  { label: 'center', value: 'center' },
];
